import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  LEAD_PROPOSALS_REFRESH: createSagaAction('LEAD_PROPOSALS_REFRESH'),
  TEMPORARILY_SAVED_LEAD_PROPOSALS_REFRESH: createSagaAction(
    'TEMPORARILY_SAVED_LEAD_PROPOSALS_REFRESH'
  ),

  LEAD_PROPOSAL_CREATE: createSagaAction('LEAD_PROPOSAL_CREATE'),
  LEAD_PROPOSAL_UPDATE: createSagaAction('LEAD_PROPOSAL_UPDATE'),
  LEAD_PROPOSAL_DELETE: createSagaAction('LEAD_PROPOSAL_DELETE'),

  GET_LEAD_PROPOSAL_SECTIONS: createSagaAction('GET_LEAD_PROPOSAL_SECTIONS'),
  GET_LEAD_PROPOSAL_ITEMS: createSagaAction('GET_LEAD_PROPOSAL_ITEMS'),

  SET_TEMPORARY_SAVED_PROPOSAL_DATA: createSagaAction('SET_TEMPORARY_SAVED_PROPOSAL_DATA'),
  UNSET_PROPOSAL_DATA: createSagaAction('UNSET_PROPOSAL_DATA')
}

// Action Creators
export const actions = {
  leadProposalsRefresh: ({ leadId, next }) => ({
    type: constants.LEAD_PROPOSALS_REFRESH.ACTION,
    leadId,
    next
  }),

  temporarilySavedLeadProposalsRefresh: ({ leadId }) => ({
    type: constants.TEMPORARILY_SAVED_LEAD_PROPOSALS_REFRESH.ACTION,
    leadId
  }),

  createLeadProposal: ({ leadId, content, proposalSections, proposalMilestones, userId }) => ({
    type: constants.LEAD_PROPOSAL_CREATE.ACTION,
    leadId,
    content,
    proposalSections,
    proposalMilestones,
    userId
  }),

  updateLeadProposal: ({
    leadId,
    proposalId,
    content,
    proposalSections,
    proposalMilestones,
    userId
  }) => ({
    type: constants.LEAD_PROPOSAL_UPDATE.ACTION,
    leadId,
    proposalId,
    content,
    proposalSections,
    proposalMilestones,
    userId
  }),

  deleteLeadProposal: ({ proposalId, leadId }) => ({
    type: constants.LEAD_PROPOSAL_DELETE.ACTION,
    leadId,
    proposalId
  }),

  getLeadProposalSections: proposalId => ({
    type: constants.GET_LEAD_PROPOSAL_SECTIONS.ACTION,
    proposalId
  }),

  getLeadProposalItems: proposalId => ({
    type: constants.GET_LEAD_PROPOSAL_ITEMS.ACTION,
    proposalId
  }),

  setTemporaryProposalData: row => ({
    type: constants.SET_TEMPORARY_SAVED_PROPOSAL_DATA.ACTION,
    row
  }),

  unsetProposalData: row => ({
    type: constants.UNSET_PROPOSAL_DATA.ACTION,
    row
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.LEAD_PROPOSALS_REFRESH.ACTION:
      return { ...state, error: null, loading: true }
    case constants.LEAD_PROPOSALS_REFRESH.SUCCESS:
      return {
        ...state,
        leadProposals: action.payload
      }
    case constants.LEAD_PROPOSALS_REFRESH.FAILED:
      return {
        error: action.message
      }

    case constants.TEMPORARILY_SAVED_LEAD_PROPOSALS_REFRESH.ACTION:
      return { ...state, error: null, loading: true }
    case constants.TEMPORARILY_SAVED_LEAD_PROPOSALS_REFRESH.SUCCESS:
      return {
        ...state,
        temporarilySavedLeadProposals: action.payload
      }

    case constants.LEAD_PROPOSAL_CREATE.SUCCESS:
      return {
        ...state
      }
    case constants.LEAD_PROPOSAL_UPDATE.SUCCESS:
      return {
        ...state
      }
    case constants.LEAD_PROPOSAL_DELETE.SUCCESS:
      return {
        ...state
      }
    case constants.GET_LEAD_PROPOSAL_SECTIONS.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_LEAD_PROPOSAL_SECTIONS.SUCCESS:
      return {
        ...state,
        leadProposalSections: action.payload
      }
    case constants.GET_LEAD_PROPOSAL_ITEMS.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_LEAD_PROPOSAL_ITEMS.SUCCESS:
      return {
        ...state,
        leadProposalItems: action.payload
      }

    case constants.SET_TEMPORARY_SAVED_PROPOSAL_DATA.ACTION: {
      const leadProposalItems = action.row.proposalSections.map(proposalSection => {
        return proposalSection.items
      })
      const leadProposalSections = action.row.proposalSections.map(proposalSection => {
        delete proposalSection.items
        return proposalSection
      })
      return {
        ...state,
        error: null,
        loading: false,
        leadProposalItems: { data: leadProposalItems.flat(1) },
        leadProposalSections: { data: leadProposalSections },
        proposalMilestones: { data: action.row.proposalMilestones }
      }
    }

    case constants.UNSET_PROPOSAL_DATA.ACTION: {
      return {
        ...state,
        error: null,
        loading: false,
        leadProposalItems: { data: [] },
        leadProposalSections: { data: [] },
        proposalMilestones: { data: [] }
      }
    }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/leadFunctions/leadProposalActions.js